module.exports = __webpack_public_path__ + "static/media/20170627_165306.8d6cbec7.jpg";